import { isNumberZero } from 'utils/numberHelpers';
import { maybeLocalizeCurrencyValue, maybeLocalizeInteger } from 'utils/i18nHelpers';
import { NumberInsightPanel } from './NumberInsightPanel';
import { useTranslation } from '../../../hooks';
import { useBehaviorQueryContext } from '../../../contexts/behaviorInsights/behaviorQuery';

export const FixedInsights = () => {
  const { t } = useTranslation();
  const { avgOrderValue, uniquePurchases, revenue, totalPurchases } = useBehaviorQueryContext();

  const localizedTotalPurchases = maybeLocalizeInteger(totalPurchases?.value);
  const localizedUniquePurchases = maybeLocalizeInteger(uniquePurchases?.value);
  const localizedRevenueValue = maybeLocalizeCurrencyValue(revenue?.value);
  const localizedAvgOrderValue = maybeLocalizeCurrencyValue(avgOrderValue?.value);
  return (
    <>
      <NumberInsightPanel
        title={t('insights.totalPurchases')}
        value={localizedTotalPurchases}
        isZero={isNumberZero(totalPurchases?.value)}
      />
      <NumberInsightPanel
        title={t('insights.uniquePurchases')}
        value={localizedUniquePurchases}
        isZero={isNumberZero(uniquePurchases?.value)}
      />
      <NumberInsightPanel
        title={t('insights.revenue')}
        value={localizedRevenueValue}
        isZero={isNumberZero(revenue?.value)}
      />
      <NumberInsightPanel
        title={t('insights.avgOrderValue')}
        value={localizedAvgOrderValue}
        isZero={isNumberZero(avgOrderValue?.value)}
      />
    </>
  );
};
